import { StoreContext } from '@roc/feature-app-core';
import { useContext } from 'react';
import { LeadsStore } from '../stores/leadsStore';

export const useLeadsStore = () =>
  useContext<{
    leadsStore: LeadsStore;
  }>(StoreContext);
